import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@marineform/environment';
import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { from, map, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileStorageService {
  readonly storageUrl = environment.tenantStorageBaseUrl;
  readonly #http = inject(HttpClient);

  uploadFile(uuid: string, file: File): Observable<void> {
    const url = `${this.storageUrl}/${uuid}`;
    return from(this.#fileToBase64(file)).pipe(
      switchMap((base64File) => {
        if (!Capacitor.isNativePlatform()) {
          return this.#http
            .put(url, base64File, { withCredentials: true })
            .pipe(map(() => undefined));
        }
        return from(this.#uploadNative(url, base64File)).pipe(map(() => undefined));
      }),
    );
  }

  async #uploadNative(url: string, file: string): Promise<void> {
    await CapacitorHttp.put({
      url,
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      data: file,
      webFetchExtra: {
        credentials: 'include',
      },
    });
  }

  #fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
}
